import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/ini";

/**
 * Classe de gerenciamento de chamadas da API dos módulos
 *
 * @class
 */
export default class IniApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe IniApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
     * Carrega o blob de configuração INI para um módulo de aplicação específico.
     * 
     * @param parametro - Parâmetro de configuração desejado.
     * @param registroAplicacao - Registro do módulo de aplicação.
     * @returns Uma lista de módulos de aplicação.
     */

    CarregarIniBlob(parametro: string, registroAplicacao: string) {
        return this.api<ApplicationModule[]>(
            `${controller}/CarregarIniBlob`,
            {
                method: "GET",
                params: {
                    parametro,
                    registroAplicacao,
                },
            },
        );
    }

    /**
     * Cadastra o blob de configuração INI para um módulo de aplicação específico.
     * 
     * @param IniBlob - Objeto contendo as informações do blob de configuração INI.
     * @returns Uma lista de módulos de aplicação.
     */

    CadastrarIniBlob(IniBlob: IniBlob) {
        return this.api<any>(
            `${controller}/CadastrarIniBlob`,
            {
                method: "POST",
                body: IniBlob,
            },
        );
    }

    CarregarIni(parametro: string, registroAplicacao: string) {
        return this.api<Ini>(
            `${controller}/CarregarIni`,
            {
                method: "GET",
                params: {
                    parametro,
                    registroAplicacao,
                },
            },
        );
    }

    CadastrarIni(Ini: Ini) {
        return this.api<any>(
            `${controller}/CadastrarIni`,
            {
                method: "POST",
                body: Ini,
            },
        );
    }
}
